import { useMemo } from 'react'
import qrcode from 'qrcode-generator'

/**
 * A QR code as one SVG path (no injected HTML). Level M survives a scuffed label: up to ~15%
 * of the symbol can be unreadable. The quiet zone is part of the drawing, so a label never
 * crops it.
 */
export function Qr({ value, size = 96, title }: { value: string; size?: number; title?: string }) {
  const { d, n } = useMemo(() => {
    const qr = qrcode(0, 'M')
    qr.addData(value)
    qr.make()
    const count = qr.getModuleCount()
    let path = ''
    for (let r = 0; r < count; r++)
      for (let c = 0; c < count; c++)
        if (qr.isDark(r, c)) path += `M${c + 4} ${r + 4}h1v1h-1z`
    return { d: path, n: count + 8 }
  }, [value])
  return (
    <svg viewBox={`0 0 ${n} ${n}`} width={size} height={size} shapeRendering="crispEdges" role="img" aria-label={title ?? value}>
      <rect width={n} height={n} fill="#fff" />
      <path d={d} fill="#000" />
    </svg>
  )
}
